import React, { useState } from 'react'
import { omit } from 'lodash'
let tempErrors = {};
const useForm = (callback, validate) => {

    //Form values
    const [values, setValues] = useState(null);
    //Errors
    const [errors, setErrors] = useState({});



    //A method to handle form inputs
    const handleChange = (event) => {
        //To stop default events    
        event.persist();

        let name = event.target.name;
        let val = event.target.value;
        
        let displayName = (event.target.labels != null && event.target.labels.length > 0) ? event.target.labels[0].innerText : event.target.name;
        
        val = validate(name, val, displayName);
        //Let's set these values in state
        
        setValues({
            ...values,
            [name]: val,
        })
    }


    const handleSubmit = (event) => {
        if (event) event.preventDefault();

        tempErrors = {};
        for (const element of event.target.elements) {
            let displayName = (element.labels != null && element.labels.length > 0) ? element.labels[0].innerText : element.name;
            validate(element.name, element.value, displayName);
        }

        setErrors(tempErrors);
        if (Object.keys(tempErrors).length === 0 && Object.keys(values).length !== 0) {
            callback();
        }
    }

    const updateError = (name, message = null) => {

        if (message != null) {

            setErrors(prevErrors => ({ ...prevErrors, [name]: message }));
            tempErrors = { ...tempErrors, [name]: message };
        }
        else {
            let newObj = omit(errors, name);
            setErrors(newObj);
            let newTmpObj = omit(tempErrors, name);
            // tempErrors = { ...newTmpObj };
        }
    }


    return {
        values,
        errors,
        handleChange,
        handleSubmit,
        setValues,
        updateError
    }
}

export default useForm